import type { InputAccessRights } from '../../_base/InputCaptureManager';

/**
 * Permissive pre-connect input access for quickstart.
 *
 * Touch defaults ON. The host delivers the authoritative access via
 * `setInputAccess` (bridged through `captureStore`) once the peer connects; this
 * is only the snapshot used before that arrives. Defaulting touch OFF froze
 * touch-native campaigns out, because the capture manager would never bind touch
 * listeners and (previously) had no way to re-bind them after the host message.
 */
export const getDefaultInputAccess = (): InputAccessRights => ({
  mouse: true,
  keyboard: true,
  gamepad: true,
  touch: true,
});

/**
 * Fail-closed input access for a live (non-debug) quickstart session.
 *
 * Live sessions start with every input denied and only enable what the host
 * grants via `setInputAccess`. This removes the permissive split-brain that let
 * touch pass through and the mobile controller appear before/without a host
 * grant (#13843). The host always sends the player's access on join
 * (CampaignInputManager), so nothing is stranded.
 */
export const getDeniedInputAccess = (): InputAccessRights => ({
  mouse: false,
  keyboard: false,
  gamepad: false,
  touch: false,
});
